import { useToast } from "primevue/usetoast";

export function showToast() {
  const toast = useToast();

  const kcAlertClasses = ["info", "success", "error", "warning"];
  const alertSeverity = {
    info: "info",
    success: "success",
    error: "error",
    warning: "warn",
  };

  kcAlertClasses.forEach((kcAlertClass) => {
    const alertDiv = document.querySelector(".alert-" + kcAlertClass);
    if (!alertDiv) return;

    const alertTitle =
      alertDiv.querySelector(".kcAlertTitleClass")?.textContent;

    toast.add({
      severity: alertSeverity[kcAlertClass],
      summary: alertTitle,
    });
  });
}
